
import Footer from "../Components/footer";
import { Link } from "react-router-dom";
import RegisterVisual from "../Components/Visual/registerVisual";

function Loading() {
  return (
    <>
        <div className="navbar">
            
            <Link to="/">
                <img src="./img/logo_MyNextDPP.svg" alt="DPP logo" className="logo" />
            </Link>
            <div className="nav-links">
            </div>
        </div>
        <RegisterVisual title={""}/>
        <div className="explorer">
            <div className="loading-page">
                <div>Loading </div>
                <div className="lds-dual-ring" style={{paddingBottom:"14px"}}></div>
            </div>
        </div>
        <Footer />
    </>
  );
}
export default Loading;